<template>
  <div
    class="alert"
    :class="{
      'alert-success': messageInfo.isSuccess,
      'alert-danger': !messageInfo.isSuccess
    }"
    role="alert"
    v-if="messageInfo.show"
  v-html="messageInfo.message">    
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      messageInfo: "getMessageInfo"
    })
  }
};
</script>
